import { Variants } from 'framer-motion'
import { theme } from 'styles/theme'

export const variants: Variants = {
  initial: {
    translateX: '100%',
  },
  enter: {
    translateX: 0,
    transition: {
      type: 'tween',
      duration: 0.4,
      ease: theme.easeValues.out,
    },
  },
  exit: {
    translateX: '100%',
    transition: {
      type: 'tween',
      duration: 0.3,
      ease: theme.easeValues.in,
    },
  },
}
